import { render, staticRenderFns } from "./ScaleAnatomy.vue?vue&type=template&id=69110f28&scoped=true&"
import script from "./ScaleAnatomy.vue?vue&type=script&lang=js&"
export * from "./ScaleAnatomy.vue?vue&type=script&lang=js&"
import style0 from "./ScaleAnatomy.vue?vue&type=style&index=0&id=69110f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69110f28",
  null
  
)

export default component.exports